export default "__VITE_ASSET__D4xaOlg6__"